exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.user-info-table tr:first-child td {\n  border-top: none;\n}\ntable.user-info-table td {\n  padding-left: 0px !important;\n}\n.card-block {\n  position: relative;\n}\n", ""]);

// exports
